import React, { useEffect } from "react";

import { Helmet } from 'react-helmet-async';
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MembAccnDtlInfoUi from "./MembAccnDtlInfoUi";
import MembGameSvcMnyUi from "./MembGameSvcMnyUi";
import MembOtpRegChkInqUi from "./MembOtpRegChkInqUi";
import MembPrfLangSetUi from "./MembPrfLangSetUi";
import "Assets/css/MyPage.css";
import MembMktgAgreUi from "./MembMktgAgreUi";
import MembQnaTop1Ui from "./MembQnaTop1Ui";
import MgpStore from "Stores/Store";

const MembIngameIdntMthdSussUi =() => {
    const langData:any = useOutletContext();
     const navigate = useNavigate();
    // Redux selector로 실시간 감지
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00}</p>
            </div>
            {/* 회원정보 */}
            <div className="myPageSubCtxtWrap container640">
            
                <h2 className="idntMthdChngTitl">경품 수령 정보 등록이 완료되었습니다!</h2>
                {/* email인증회원은 휴대폰인증으로 인증방식 변경이 가능합니다. */}
                <div className="idntMthdChngTxtWrap">
                    <div className="idntMthdChngImgWrap">
                        <img src={process.env.PUBLIC_URL+'/images/MbpAthnIcon.png'} alt="" />
                    </div>
                    <div className='idntMthdChngTxt'>
                        <p>
                            게임으로 돌아가 기프티콘 아이템을 사용하여 수령 신청을 완료해 주세요.
                        </p>
                    </div>
                </div>
            </div> 
        </div>
        </>
    )
}


export default MembIngameIdntMthdSussUi;